
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';

import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SaladasScreen from './salads';
import TacosScreen from './tacos';
import QuesadillasScreen from './quesadillas';
import TortasScreen from './tortas';
import FajitasScreen from './fajitas';
import SandwichesScreen from './sandwich';
function Index({dishs, setShowListProduct, top = 0}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const {  menus: menusCurrent, name: title } = dishs;

     const [showSaladas, setShowSaladas] = useState(false);
    const [showTacos, setShowTacos] = useState(false);
    const [showQuesadillas, setShowQuesadillas] = useState(false);
    const [showTortas, setShowTortas] = useState(false);
    const [showFajitas, setShowFajitas] = useState(false);
    const [showSandwiches, setShowSandwiches] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [menusData, setMenusData] = useState([]);
    const [menus, setMenus] = useState(menusCurrent);

    
     useEffect(() => {
                getData('menu').then((items) => {
                    const data = items.value.data;
                    setMenusData(data);
                });
     }, []);
    
    useEffect(() => {
        
    }, [menus]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 340,
                maxHeight: 500,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                padding: 20, boxSizing: 'border-box',
                borderRadius: 20
            }}>
                <img src={image}  style={{width: '100%', height: 320, objectFit: 'cover', borderRadius: 25}}/>
                <h3 style={
                    { color: 'black', fontWeight: '900',textTransform: 'uppercase', fontSize: 27, margin: 0,  marginTop: 10, textAlign: 'center' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '95%', marginTop: 10}}>
                    <p
                        className='shor-text'
                        style={{ fontSize: 14, color: '#000', margin: 0,marginLeft: 25,fontWeight: 'bold', textAlign: 'center'}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>
                
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top, left: 0, width: '100%', height: '100%'}}>
            <LayoutContent showBack={true} showLogo={true} setShowListProduct={ () =>setShowListProduct(false) }>
                <div>
                    <div style={{
                    background: 'white',
                        width: '92%',
                    height: 60,
                    margin: '0 auto',
                    display: 'flex',
                    padding: '10px 10px',
                    gap: 10,
                    justifyContent: 'space-between',
                    overflow: 'scroll',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 14
                }}>
                    {menusData.map((item, key) => {
                            if (![591, 592, 568, 593].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: 'linear-gradient(90deg, #F93C36 0%, #92080B 100%)',

                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '5px 15px',
                                     borderRadius: 14
                            }}
                                    onClick={() => { 
                                        if (item.id === 571) {
                                            setShowSaladas(true)
                                        } else if (item.id === 580) {
                                            setShowTacos(true)
                                        }else if (item.id === 581) {
                                            setShowQuesadillas(true)
                                        } else if (item.id === 582) {
                                            setShowTortas(true)
                                        }else if (item.id === 583) {
                                            setShowFajitas(true)
                                        }else if (item.id === 569) {
                                            setShowSandwiches(true)
                                        } else {
                                            setMenus(item.menus)
                                        }
                                     }}
                                >
                                <p className='shor-text' style={{color: 'white', fontWeight: "900",fontSize: 15}}>{item.name}</p>

                            </div>
                            }
                            
                        })}
                </div>


                    
                   <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '0px 10px 100px 10px',
                            overflow: 'scroll',
                            height: 680,
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                        </div>   

                
                
                </div>
                {showDetailProduct && <DetailProduct
                dishMenu={dataDish}
                setShowDetailProduct={setShowDetailProduct}
            />}
            {showSaladas && <SaladasScreen setShowSaladas={setShowSaladas} />}
            {showTacos && <TacosScreen setshowTacos={setShowTacos} />}
            {showQuesadillas && <QuesadillasScreen setshowQuesadillas={setShowQuesadillas} />}
            {showTortas && <TortasScreen setshowTortas={setShowTortas} />}
            {showFajitas && <FajitasScreen setshowFajitas={setShowFajitas} />}
            {showSandwiches && <SandwichesScreen setShowSandwiches={setShowSandwiches} />}
            </LayoutContent>
        </div>
    );
}
export default Index;